import { Img as BaseImg, ImgProps } from '@wyz/ui';
import { useApplicationContext } from '~/common/context';

const Img = (props: Omit<ImgProps, 'getToken'>) => {
  const { auth } = useApplicationContext();
  return (
    <BaseImg {...props} getToken={() => auth.user?.access_token as string} />
  );
};

export default Img;
